enum ErrorCodes {
  INVALID_REQUEST_PARAMS = 'Invalid request params',
  INVALID_REQUEST_BODY = 'Invalid request body',
  SERVER_ERROR = 'Unexpected server error occurred',
  INVALID_ENVIRONMENT = 'The configured environment is invalid',
  INTERNAL_DB_CONNECTION_ERROR = 'The internal db connection was not found',
  DB_CONNECTION_ERROR = 'The associated db connection was not found',
  NOT_FOUND = 'Not found',
  VALIDATION_ERROR = 'Validation error',
  AUTHORIZATION_ERROR = 'Unauthorized',
  FORBIDDEN = 'Forbidden',
  CONFLICT = 'Conflict',
  UNKNOWN_ERROR = 'An unknown error occurred',
  TOO_MANY_REQUESTS = 'Too many requests',
  ALREADY_EXISTS = 'Already exists',
  MFA_ERROR = 'MFA token invalid',
  WRONG_PASSWORD_ERROR = 'Wrong Password',
  MFA_ENFORCED_LOGIN_ERROR = '2FA enforced by company, wrong token',
  INVALID_FILE_CONTENT = 'Invalid file content',
  INVALID_FAQ_FILE_CONTENT = 'Invalid file content. The question and answer fields are mandatory.',
  INVALID_WIKI_FILE_CONTENT = 'Invalid file content. The information field is mandatory.',
  INVALID_PRODUCT_FILE_CONTENT = 'Invalid file content. The title, description and price fields are mandatory.',
  INVALID_URL_IN_FILE_CONTENT = 'Invalid file content. URLs are formatted incorrectly',
  INVALID_FILE_CONTENT_EMPTY = 'Invalid file content. File is empty',
  EXTERNAL_SERVER_ERROR = 'An external server error occurred while processing the request. Please try again.',
  INTERNAL_SERVER_ERROR = 'An internal server error occurred while processing the request. Please try again.',
  MICROSOFT_SSO_INVALID_STATE = 'Invalid state parameter for Microsoft SSO',
  MICROSOFT_SSO_MISSING_CODE = 'Missing authorization code from Microsoft',
  MICROSOFT_SSO_TOKEN_EXCHANGE_FAILED = 'Failed to exchange authorization code for tokens',
  MICROSOFT_SSO_USER_VALIDATION_FAILED = 'Failed to validate user from Microsoft token',
  MICROSOFT_SSO_USER_NOT_FOUND = 'User not found in system',
  MICROSOFT_SSO_INVALID_ID_TOKEN = 'Invalid ID token from Microsoft',
  MICROSOFT_SSO_MISSING_EMAIL = 'Missing email in Microsoft token',
  MICROSOFT_SSO_FEATURE_NOT_ENABLED = 'Your company is not yet able to use Single Sign On (SSO). If you would like to use this feature please contact sales@conversed.ai',
  SCRAPER_URL_NOT_REACHABLE = 'URL is not reachable',
  SCRAPER_URL_NOT_FOUND = 'URL does not exist',
  ARTICLE_ARCHITECT_UNSUPPORTED_FILE_TYPE = 'Unsupported file type for article generation',
  ARTICLE_ARCHITECT_FILE_TOO_LARGE = 'File exceeds the maximum allowed size for article generation',
  ARTICLE_ARCHITECT_GENERATION_FAILED = 'Article generation failed',
  ARTICLE_ARCHITECT_BCC_NOT_CONFIGURED = 'No BCC email address configured for this company',
  ARTICLE_ARCHITECT_JOB_ALREADY_RUNNING = 'Article generation is already in progress',
  ARTICLE_ARCHITECT_CONFLICT_SCAN_ALREADY_RUNNING = 'A conflict scan is already in progress for this company',
  ARTICLE_ARCHITECT_UNRESOLVED_CONFLICTS = 'This article cannot be published while it still has unresolved conflicts',
  ARTICLE_ARCHITECT_CONFLICT_CHECK_FAILED = 'The conflict check could not run, so the article was not published',
  ARTICLE_ARCHITECT_ESTIMATE_FAILED = 'The article estimate could not be completed',
  ARTICLE_ARCHITECT_BACKFILL_SCOPE_NOT_CONFIGURED = 'No TopDesk backfill scope is configured for this company',
  ARTICLE_ARCHITECT_BACKFILL_SCOPE_INVALID = 'The TopDesk backfill scope configured for this company is invalid',
  ARTICLE_ARCHITECT_NO_PULL_ARTIFACT = 'No TopDesk ticket pull is available for this company',
  ARTICLE_ARCHITECT_ESTIMATE_EXPIRED = 'The article estimate is no longer valid',
  TICKET_DEFLECTION_RESPONSE_NOT_FOUND = 'Response not found',
  PUBLIC_API_LLM_BLOCK_NOT_FOUND = 'LLM block not found',
  PUBLIC_API_LLM_BLOCK_REVISION_NOT_FOUND = 'No revision found for the selected LLM block',
  PUBLIC_API_LLM_BLOCK_CONFIG_NOT_FOUND = 'No webclient config found for the selected LLM block revision',
  VOICE_AI_AGENTS_UNAVAILABLE = 'Failed to fetch the voice agent list from ElevenLabs',
  HISTORY_EXPORT_CONFLICT = 'A history export config already exists',
  JOB_ALREADY_RUNNING = 'A job is already in progress',
  PSEUDONYMIZATION_JOB_ALREADY_RUNNING = 'A pseudonymization run is already in progress',
  PROVISIONING_TEARDOWN_ALREADY_IN_PROGRESS = 'A teardown is already in progress for this company',
  PROVISIONING_TEARDOWN_NOT_ELIGIBLE = 'This company cannot be deprovisioned in its current state',
  COMPANY_DEPROVISIONED_CANNOT_ACTIVATE = 'A deprovisioned company cannot be activated',
  INTENT_REDIRECT_NOT_REVIEWABLE = 'An intent redirect question has no A.I. answer and cannot be reviewed',
  CONVERSATION_WITHOUT_ANSWER_NOT_TRANSLATABLE = 'A conversation without an answer cannot be translated',
  DATA_SOURCE_SUBFOLDER_NOT_EMPTY = 'This subfolder still contains files',
  WEEKLY_BRIEF_DISABLED = 'Turn on the Weekly Intelligence Brief for this client before approving a brief',
}

export default ErrorCodes;
